import React from 'react';
import { Link } from 'lucide-react';

export function AffiliateDisclaimer() {
  return (
    <section className="mb-8">
      <div className="flex items-center gap-2 mb-4">
        <Link className="h-5 w-5 text-emerald-600" />
        <h2 className="text-2xl font-semibold">Affiliate Links</h2>
      </div>
      
      <div className="prose prose-emerald max-w-none">
        <p>
          <strong>Affiliate Link Disclosure:</strong> This platform may contain affiliate links to 
          financial services, trading platforms, educational resources, and other products. We may 
          earn a commission at no extra cost to you if you make a purchase through these links.
        </p>
        
        <p>
          <strong>We are not responsible</strong> for the accuracy, quality, reliability, or 
          performance of products or services provided by affiliate partners. Any affiliate 
          relationships do not influence our editorial content or exchange rate data.
        </p>
        
        <p>
          <strong>Due Diligence Required:</strong> Please conduct your own research and due 
          diligence before engaging with any affiliate partners. Verify licensing, regulation, 
          and legitimacy of all financial service providers.
        </p>
        
        <p className="text-emerald-600 font-medium">
          Your support through affiliate links helps us maintain this free informational platform. 
          Thank you for supporting NigeriaFx!
        </p>
      </div>
    </section>
  );
}